import * as types from '../types'
import { getHotPort } from '@/api/model/gen'
import { setStorage, getStorage } from '@/hiti/Storage.js'
export default {
  state: {
    polList: [],

    pol: getStorage('pol', {
      portNameCn: '上海',
      portNameEn: 'SHANGHAI',
      portCode: 'CNSHA',
    }),
    pod: {},
  },

  getters: {
    polList: (state) => {
      return state.polList
    },
    pol: (state) => {
      return state.pol
    },
    pod: (state) => {
      return state.pod
    },
  },
  mutations: {
    [types.SELECT_POL](state, pol) {
      setStorage('pol', pol)
      Object.assign(state.pol, pol)
    },
    [types.GET_POL](state, polList) {
      state.polList = polList
    },
    [types.SELECT_POD](state, pod) {
      state.pod = pod || {}
    },
  },
  actions: {
    [types.GET_POL]({ commit, state }) {
      if (state.polList.length <= 0) {
        getHotPort({
          // sort: 'DESC',
          // // hotPortFlag: 1,
          // lineCode: 'S02',
          // compCode: 'YUNJIA'
          queryMap: { lineCode: 'S02', compCode: 'YUNJIA' },
        }).then((data) => {
          commit(types.GET_POL, data)
        })
      }
    },
    [types.SELECT_POL]({ commit }, pol) {
      commit(types.SELECT_POL, pol)
    },
    [types.SELECT_POD]({ commit }, pol) {
      commit(types.SELECT_POD, pol)
    },
  },
}
